(() => {
  'use strict';
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('es');
  document.querySelectorAll('[data-slf-search]').forEach(root => {
    const input = root.querySelector('[data-slf-search-query]');
    const rows = Array.from(root.querySelectorAll('[data-slf-search-item]'));
    const count = root.querySelector('.slf-search-count');
    function search() {
      const tokens = normalize(input.value).trim().split(/\s+/).filter(Boolean);
      let total = 0;
      rows.forEach(row => { row.hidden = !tokens.every(token => normalize(row.dataset.search).includes(token)); if (!row.hidden) total++; });
      count.textContent = total + (total === 1 ? ' producto' : ' productos');
      root.querySelector('[data-slf-search-empty]').hidden = total !== 0;
    }
    input.addEventListener('input', search);
    input.addEventListener('keydown', event => {
      if (event.key === 'Escape') { root.open = false; root.querySelector('summary').focus(); }
      if (event.key === 'Enter') event.preventDefault();
    });
    root.addEventListener('toggle', () => { if (root.open) input.focus(); });
    search();
  });
  document.querySelectorAll('[data-slf-catalog]').forEach(root => {
    const form = root.querySelector('[data-slf-controls]');
    if (!form) return;
    const grid = root.querySelector('[data-slf-grid]');
    const rows = Array.from(grid.querySelectorAll('[data-slf-card]'));
    const sort = form.querySelector('[data-slf-sort]');
    const available = form.querySelector('[data-slf-available]');
    const min = form.querySelector('[data-slf-min]');
    const max = form.querySelector('[data-slf-max]');
    function apply() {
      min.setCustomValidity(''); max.setCustomValidity('');
      if (min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value)) {
        max.setCustomValidity('El precio máximo debe ser igual o mayor que el mínimo.'); form.reportValidity(); return;
      }
      const low = min.value === '' ? 0 : Number(min.value) * 100;
      const high = max.value === '' ? Infinity : Number(max.value) * 100;
      const sorted = rows.slice().sort((a, b) => {
        const price = Number(a.dataset.price) - Number(b.dataset.price);
        const title = a.dataset.title.localeCompare(b.dataset.title, 'es', { sensitivity: 'base' });
        if (sort.value === 'price-asc') return price;
        if (sort.value === 'price-desc') return -price;
        if (sort.value === 'title-asc') return title;
        if (sort.value === 'title-desc') return -title;
        return Number(a.dataset.sourceOrder) - Number(b.dataset.sourceOrder);
      });
      let total = 0; let purchasable = 0;
      sorted.forEach(row => {
        const price = Number(row.dataset.price);
        const ready = row.dataset.available === 'true';
        row.hidden = (available.checked && !ready) || price < low || price > high;
        if (!row.hidden) { total++; if (ready) purchasable++; }
        grid.appendChild(row);
      });
      root.querySelector('[data-slf-count]').textContent = total + ' productos · ' + purchasable + ' disponibles para comprar';
      root.querySelector('[data-slf-filter-empty]').hidden = total !== 0;
    }
    form.addEventListener('submit', event => { event.preventDefault(); if (form.reportValidity()) apply(); });
    form.addEventListener('input', () => { min.setCustomValidity(''); max.setCustomValidity(''); });
    sort.addEventListener('change', apply);
    available.addEventListener('change', apply);
    form.addEventListener('reset', () => { min.setCustomValidity(''); max.setCustomValidity(''); setTimeout(apply, 0); });
    apply();
  });
})();
